import { render, staticRenderFns } from "./destOrdersForm.vue?vue&type=template&id=7e15637a&"
import script from "./destOrdersForm.vue?vue&type=script&lang=js&"
export * from "./destOrdersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports